import Vue from 'vue'
import './plugins/axios'
import './plugins/fontawesome'
import './plugins/logger'
import App from './App.vue'
import router from './router'
import store from './store'
import Keycloak from 'keycloak-js'


Vue.config.productionTip = false


let initOptions = {
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
    onLoad: 'login-required',
}

let keycloak = new Keycloak(initOptions);
Vue.prototype.$keycloak = keycloak
// console.log(initOptions)

keycloak.init({checkLoginIframe: false, onLoad: initOptions.onLoad}).then((auth) => {

    if (auth) {
        localStorage.setItem('accessToken', keycloak.token)
        store.dispatch('setAccessToken', keycloak.token)

        keycloak.loadUserInfo().then(userInfo => {
            // console.log(userInfo)
            store.dispatch('setUserInfo', userInfo)
            let mode = 'account'
            if (userInfo.roles && userInfo.roles.includes('consultant')) {
                mode = 'partner'
            }
            if (userInfo.roles && userInfo.roles.includes('superadmin')) {
                mode = 'admin'
            }
            store.dispatch('setMode', mode)
        })
    }

    new Vue({
        router,
        store,
        render: h => h(App, {props: {keycloak: keycloak}})
    }).$mount('#app')


    //Token Refresh
    setInterval(() => {
        // eslint-disable-next-line no-unused-vars
        keycloak.updateToken(70).then((refreshed) => {
            // if (refreshed) {
            //   Vue.$log.info('Token refreshed' + refreshed);
            // } else {
            //   Vue.$log.warn('Token not refreshed, valid for '
            //     + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
            // }
        }).catch(() => {
            Vue.$log.error('Failed to refresh token');
        });
    }, 6000)

// eslint-disable-next-line no-unused-vars
}).catch((e) => {
    Vue.$log.error("Authenticated Failed");
});
